<template>
    <v-dialog
        v-model="dialog"
        :width="width"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="primary"
                outlined
                text
                v-bind="attrs"
                v-on="on"
            >
                Upload Students
            </v-btn>
        </template>

        <v-expand-transition>
            <v-card
                v-show="expandFileSelect"
            >
                <v-card-title>
                    Upload Students
                    <v-btn
                        icon
                        class="ml-auto"
                        @click="close"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col>
                                <v-file-input
                                    v-model="file"
                                    show-size
                                    label="Click to select file to upload."
                                    @change="selectFile"
                                ></v-file-input>
                            </v-col>    
                        </v-row>
                        <v-row v-if="file">
                            <v-progress-linear
                                v-model="progress"
                                color="primary"
                                height="25"
                                reactive
                            >
                                <strong>{{ progress }} %</strong>
                            </v-progress-linear>
                        </v-row>

                        <v-alert v-if="message" border="left" :color="messageColor" dark>
                            {{ message }}
                        </v-alert>

                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        outlined
                        class="mr-2"
                        color="primary"
                        @click="close"
                    >
                        Cancel Upload
                    </v-btn>
                    <v-btn
                        class="mr-2"
                        color="primary"
                        @click="downloadTemplate"
                    >
                        Download Template
                    </v-btn>
                    
                </v-card-actions>
                <v-overlay
                    :value="overlayDownload"
                    :absolute="true"
                    color="#fff"
                    opacity="0.9"
                >
                    <v-progress-circular                        
                        indeterminate
                        size="64"
                        color="primary"
                    ></v-progress-circular>
                </v-overlay>
            </v-card>
        </v-expand-transition>

        <v-expand-transition>
            <v-card
                v-show="expandConfirmUpload"
                max-height="95vh"
            >
                <!-- <v-card-title>{{ uploadConfirmText }}</v-card-title> -->
                <v-card-title>Confirm Upload Students</v-card-title>
                <v-card-text>
                    <v-data-table
                        v-model="selected"
                        :headers="headers"
                        :items="students"                    
                        height="45vh"
                        fixed-header
                        :items-per-page="itemsPerPage"
                        :loading="loading"
                        :show-select="showSelect"
                    >
                        <template v-slot:item="{ item, headers }">
                            <tr>
                                <td
                                    v-for="(h, index) in headers"
                                    :key="index"
                                >
                                    <span v-if="h.value != 'actions'">
                                        {{ item[h.value] }}
                                    </span>
                                    <span v-else>
                                        <v-icon
                                            v-if="uploadComplete && !item.error"
                                            small
                                            color="green"                            
                                        >
                                            mdi-check-all
                                        </v-icon>
                                        <v-icon
                                            v-if="uploadComplete && item.error"
                                            small
                                            color="red"                            
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions
                    class="px-6"
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="!uploadComplete && !deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeUploadConfirm"
                    >
                        Cancel Upload
                    </v-btn>
                    <v-btn
                        v-if="deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeDeleteRecords"
                    >
                        <v-icon left>mdi-arrow-left</v-icon>
                        Back
                    </v-btn>
                    <v-btn
                        v-if="deleteRecords"
                        color="primary"
                        dark
                        small
                        class="mr-2"
                        @click="deleteSelectedRecords"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        v-if="!uploadComplete && deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="selectRecords"
                    >
                        Delete Records
                    </v-btn>
                    <v-btn
                        v-if="!uploadComplete && !deleteRecords"
                        color="primary"
                        dark
                        small
                        @click="uploadConfirm"
                    >
                        Confirm Upload
                    </v-btn>
                    <v-btn
                        v-if="uploadComplete && !deleteRecords"
                        color="primary"
                        outlined
                        small
                        class="mr-2"
                        @click="closeUploadConfirm"
                    >
                        Close
                    </v-btn>
                </v-card-actions>

                <v-overlay
                    :value="overlay"
                    :absolute="true"
                    color="#fff"
                    opacity="0.9"
                >                
                    <v-card                    
                        flat
                        width="400"
                        light
                    >
                        <v-row
                            align-content="center"
                            justify="center"
                        >
                            <v-col 
                                cols="12"
                                class="subtitle-1 text-center"
                            >
                                {{ uploadingText }}
                            </v-col>
                            <v-col 
                                cols="6"
                                v-show="!uploadComplete"
                            >
                                <v-progress-linear
                                    v-model="progress"
                                    height="6"                        
                                    color="primary"
                                    indeterminate
                                    rounded
                                >                        
                                </v-progress-linear>
                            </v-col>
                            
                        </v-row>                    
                    </v-card>
                </v-overlay>

                <v-overlay
                    :value="overlayDeleteConfirm"
                    :absolute="true"
                    color="#fff"
                    opacity="0.9"
                >
                    <v-card 
                        class="pa-2"
                        width="300"
                        light
                    >
                        <v-row
                            align-content="center"
                            justify="center"
                        >
                            <v-col 
                                cols="12"
                                class="subtitle-1 text-center"
                            >
                                {{ deleteRecordsMessage }}
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                outlined
                                class="mr-4"
                                color="primary"
                                small
                                @click="cancelDeleteRecords"
                            >
                                Cancel
                            </v-btn>
                            <v-btn                            
                                color="primary"
                                dark
                                small
                                @click="deleteSelectedRecordsConfirm"                            
                            >
                                Delete
                            </v-btn>
                        </v-card-actions>
                    </v-card>        
                </v-overlay>
            </v-card>
        </v-expand-transition>   
        
        <v-snackbar
            v-model="snackbar.display"
            :color="snackbar.color"
        >
            {{ snackbar.text }}
            <v-btn
                color="white"
                text
                @click="snackbar.display = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import UploadService from "../services/UploadFileService";
export default {
    data: function () {
        return {
            dialog: false,
            overlay: false,
            expandFileSelect: false,
            file: null,
            progress: 0,
            message: '',
            messageColor: '',
            overlayDownload: false,
            expandConfirmUpload: false,
            uploadConfirmText: '',
            selected: [],
            students: [],
            itemsPerPage: -1,
            loading: false, 
            showSelect: false,
            uploadComplete: false,
            deleteRecords: false,
            overlayDeleteConfirm: false,
            deleteRecordsMessage: '',
            uploadingText: null,
            uploadingMessages: [
                'Please wait...',
                'Working on your request...',
                'Taking a bit long...',
                'Still working...'
            ],
            width: '700px',
            snackbar: {
                display: false,
                text: '',
                color: 'primary'
            }
        }
    },

    computed: {
        headers () {
            return [
                {text: 'Student ID', value: 'id', width: '100'},
                {text: 'Last Name', value: 'last_name', width: '120',},
                {text: 'First Name', value: 'first_name', width: '120',},
                {text: 'Other Name', value: 'other_name', width: '120',},
                {text: 'DOB', value: 'date_of_birth', width: '120',},               
                {text: 'Gender', value: 'gender', width: '75',},    
                {text: 'Birth Certificate Pin', value: 'birth_certificate_pin', width: '150',},
                {text: 'SEA Reg No.', value: 'sea_number', width: '120',},
                {text: 'Class', value: 'form_class_id', width: '100',}, 
                {text: 'Email Address', value: 'email', width: '120'},
                {text: 'Entry Date', value: 'entry_date', width: '120'},
                {text: 'Address', value: 'address_home', width: '200'},
                {text: 'Town', value: 'town', width: '120'},
                {text: 'Regional Corporation', value: 'regional_corporation', width: '150'},
                {text: 'Student Phone No.', value: 'phone_mobile', width: '120'},
                {text: 'Blood Group', value: 'blood_group', width: '100'},
                {text: 'Previous School', value: 'previous_school', width: '150'},
                {text: 'Ethnic Group', value: 'ethnic_group', width: '120'},
                {text: 'Religion', value: 'religion', width: '120'},
                {text: 'Country of Birth', value: 'country_of_birth', width: '150'},
                {text: 'Nationality', value: 'nationality', width: '120'},
                {text: 'Living Status', value: 'living_status', width: '120'},
                {text: 'Extra Curricular Activities', value: 'extra_curricular', width: '200'},
                {text: 'Device Type', value: 'device_type', width: '120'},
                {text: 'Internet Access', value: 'internet_access', width: '120'},
                {text: 'School Feeding', value: 'school_feeding', width: '120'},
                {text: 'School Transport', value: 'school_transport', width: '120'},
                {text: 'Allergies', value: 'allergies', width: '120'},
                {text: 'Other Health Info', value: 'other_health_conditions', width: '150'},
                {text: 'No. in Family', value: 'no_in_family', width: '120'},
                {text: 'No. at Home', value: 'no_at_home', width: '120'},
                {text: 'Place in Family', value: 'place_in_family', width: '120'},
                {text: 'Father name', value: 'father_name', width: '120'},
                {text: 'Father Address', value: 'father_address', width: '200'},
                {text: 'Father Occupation', value: 'father_occupation', width: '150'},
                {text: 'Father Employer', value: 'father_employer', width: '150'},
                {text: 'Father Work Address', value: 'father_work_address', width: '200'},
                {text: 'Father marital status', value: 'father_marital_status', width: '150'},
                {text: 'Father Phone (W)', value: 'father_phone_work', width: '120'},
                {text: 'Father Phone (M)', value: 'father_phone_mobile', width: '120'},
                {text: 'Father Email', value: 'father_email', width: '120'},
                {text: 'Father ID #', value: 'father_id_card', width: '120'},
                {text: 'Mother name', value: 'mother_name', width: '120'},
                {text: 'Mother Address', value: 'mother_address', width: '200'},
                {text: 'Mother Occupation', value: 'mother_occupation', width: '150'},
                {text: 'Mother Employer', value: 'mother_employer', width: '150'},
                {text: 'Mother Work Address', value: 'mother_work_address', width: '200'},
                {text: 'Mother marital status', value: 'mother_marital_status', width: '150'},
                {text: 'Mother Phone (W)', value: 'mother_phone_work', width: '120'},
                {text: 'Mother Phone (M)', value: 'mother_phone_mobile', width: '120'},
                {text: 'Mother Email', value: 'mother_email', width: '120'},
                {text: 'Mother ID #', value: 'mother_id_card', width: '120'},
                {text: 'Guardian name', value: 'guardian_name', width: '120'},
                {text: 'Guardian Address', value: 'guardian_address', width: '200'},
                {text: 'Guardian Occupation', value: 'guardian_occupation', width: '150'},
                {text: 'Guardian Employer', value: 'guardian_employer', width: '150'},
                {text: 'Guardian Work Address', value: 'guardian_work_address', width: '200'},
                {text: 'Guardian marital status', value: 'guardian_marital_status', width: '150'},
                {text: 'Guardian Phone (W)', value: 'guardian_phone_work', width: '120'},
                {text: 'Guardian Phone (M)', value: 'guardian_phone_mobile', width: '120'},
                {text: 'Guardian Email', value: 'guardian_email', width: '120'},
                {text: 'Guardian ID #', value: 'guardian_id_card', width: '120'},
                {text: 'Emergency Contact', value: 'emergency_contact_name', width: '150'},
                {text: 'Emergency Contact Phone (M)', value: 'emergency_contact_phone_mobile', width: '150'},
                {text: 'Emergency Contact Relationship', value: 'emergency_contact_relationship', width: '150'},
                {text: 'House Name', value: 'house_name', width: '120'},
                {text: 'House Color', value: 'house_color', width: '120'},
                {text: '', value: 'actions'},                
            ];
           
        }
    },

    watch: {
        dialog (val) {
            console.log(val);
            if(val) {
                this.initialize();
            }
        },

        file (val) {
            if(val) this.uploadFile();
           
        }
    },

    methods: {
        initialize () {
            console.log("initializing");
            this.width = '700px';
            this.expandFileSelect = true;
        },

        ...mapMutations({
            setNewStudents: 'students/setNewStudents',
        }),

        ...mapActions({
            downloadStudentUploadTemplate: 'students/downloadTemplate',
            uploadStudents: 'students/uploadStudents',
        }),

        downloadTemplate () {
            console.log("download template")
            this.overlayDownload = true;            
            this.downloadStudentUploadTemplate()
            .then(response => {
                const now = new Date();
                const pad = (n) => n.toString().padStart(2, '0');
                const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const filename = `Registration Upload_${timestamp}.xlsx`;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                this.overlayDownload = false;                   
            })
            .catch( error => {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.overlayDownload = false;
                
            })

        },       
        

        selectFile (file) {
            this.progress = 0;
            this.file = file;
            this.message = null;
        },

        uploadFile () {
            if(!this.file) {
                this.messageColor = "red"
                this.message = "Please select a file!";
                return;
            }

            this.message = "";
            // this.loading = true;
            this.overlayDownload = true;

            UploadService.uploadSpreadsheet(this.file, (event) => {
                this.progress = Math.round((100 * event.loaded) / event.total);
            })
            .then(({ data }) => {
                this.expandFileSelect = false;
                this.loading = false;

                setTimeout(() => {
                    this.expandConfirmUpload = true;
                    this.uploadConfirmText = "Confirm Upload Students"
                    this.width = '90vw';
                }, 700);

                
                this.students = data;
            })
            .catch((error) => {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.progress = 0;
                this.message = "Could not upload the file.";
                this.messageColor = 'red'
                this.file = null;
            })

            this.overlayDownload = false;

        },

        async uploadConfirm () {
            console.log("upload confirmed");
            this.overlay = true;
            this.uploadComplete = false;
            this.uploadingText = "Uploading Students."
            this.progress = 10;
            let messageCount = this.uploadingMessages.length;
            let index = 0;
            let messageInterval = setInterval(() => {
                if(index < (messageCount - 1)) index++;
                else index = 0;
                this.uploadingText = this.uploadingMessages[index];
                // console.log(`index: ${index}, text: ${this.uploadingMessages[index]}`)
            }, 3000);
            this.setNewStudents(this.students);
            try {
                await this.uploadStudents();
                clearInterval(messageInterval);
                this.uploadingText = "Upload Complete.";
                this.uploadComplete = true;
                this.uploadConfirmText = "Upload Complete"
                this.$emit("update-students");
                setTimeout(() => {
                    this.overlay = false
                    this.snackbar.text = "Students Uploaded Successfully.";
                    this.snackbar.color = "primary";
                    this.snackbar.display = true;
                }, 1000)

            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.overlay = false;
                this.snackbar.text = "Error Occured.Could not upload students.";
                this.snackbar.color = "red";
                this.snackbar.display = true;
            }
        },

        mapUploadedStudents (data) {
            this.students =  [];
            data.forEach(value => {
                this.students.push(value.record);
            })
        },

        selectRecords () {
            this.showSelect = true;
            this.deleteRecords = true;
            this.uploadConfirmText = "Select Records To Delete"
        },

        cancelDeleteRecords () {
            this.overlayDeleteConfirm = false;
            this.deleteRecordsMessage = '';
        },

        deleteSelectedRecordsConfirm () {
            this.cancelDeleteRecords();
            this.selected.forEach(value => {                
                this.students.splice(this.students.indexOf(value), 1);
            })
            this.selected = [];
        },

        closeUploadConfirm () {
            this.dialog = false;
            this.expandConfirmUpload = false;
            this.expandFileSelect = false;
            this.file = null;
            this.progress = 0;
            this.message = null;
            this.uploadComplete = false;
        },

        close () {
            this.dialog = false;
            this.file = null;
            this.progress = 0;
            this.message = null;
        },
    }
}
</script>

<style scoped>
    /* */
</style>